import React, { createContext, useContext, useState, ReactNode } from 'react';
import { API_CONFIG } from '../config/api';

export type CountryCode = keyof typeof API_CONFIG.COUNTRIES;

interface CountryContextType {
  selectedCountry: CountryCode;
  setSelectedCountry: (country: CountryCode) => void;
  getCountryModel: (country?: CountryCode) => string;
  availableCountries: CountryCode[];
}

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export const useCountryContext = () => {
  const context = useContext(CountryContext);
  if (context === undefined) {
    throw new Error('useCountryContext must be used within a CountryProvider');
  }
  return context;
};

interface CountryProviderProps {
  children: ReactNode;
}

export const CountryProvider: React.FC<CountryProviderProps> = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState<CountryCode>('ITALIA');
  
  const getCountryModel = (country?: CountryCode) => {
    const countryToUse = country || selectedCountry;
    return API_CONFIG.COUNTRIES[countryToUse].model;
  };

  const availableCountries = Object.keys(API_CONFIG.COUNTRIES) as CountryCode[];

  const value: CountryContextType = {
    selectedCountry,
    setSelectedCountry,
    getCountryModel,
    availableCountries,
  };

  return (
    <CountryContext.Provider value={value}>
      {children}
    </CountryContext.Provider>
  );
};